export const septemberUppercase = "zm9emc";
export default {septemberUppercase};